import { Stack } from "@similarweb/ui-components/foundations";

import { useExtensionGovernanceUsersQuery } from "app/pages/sales-intelligence/modules/extension-management/query/queries/useExtensionGovernanceUsersQuery";

import { DeploymentMethodSection } from "../../components/DeploymentMethodSection/DeploymentMethodSection";

export const DeploymentTab = () => {
    const { data: governanceUsersData } = useExtensionGovernanceUsersQuery();

    return (
        <Stack
            gap="20px"
            margin="20px 0 40px"
        >
            <DeploymentMethodSection users={governanceUsersData?.items || []} />
        </Stack>
    );
};
